import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useDeleteEvent = createTripMutation<void, { tripId: string; eventId: string }>({
	mutationFn: async ({ tripId, eventId }) => {
		await api.delete(`/trips/${tripId}/events/${eventId}`)
	},
	invalidate: ({ tripId }) => [queryKeys.events(tripId)],
})
